// extracted by mini-css-extract-plugin
module.exports = {"wordList":"WordList_wordList__2GUAj"};